import { motion } from "framer-motion";
import { Instagram, Facebook, Linkedin } from "lucide-react";

const socials = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/marcblackceo/" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/marcblackceo" },
  { icon: Linkedin, label: "LinkedIn", href: "https://www.linkedin.com/in/marcblackceo/" },
];

const pillars = [
  { k: "Lead", v: "with purpose" },
  { k: "Build", v: "with discipline" },
  { k: "Unlock", v: "with intention" },
];

export default function About() {
  return (
    <section id="about" className="relative py-24 sm:py-32 overflow-hidden" data-testid="about-section">
      <div className="light-bleed h-[420px] w-[420px] top-1/3 -left-40 opacity-25" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="relative rounded-3xl overflow-hidden border border-white/10">
            <img
              src="/assets/marc-black-ceo-stairs.jpeg"
              alt="Marc Black CEO"
              className="w-full h-[520px] object-cover object-top"
              data-testid="about-host-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
            <div className="absolute bottom-6 left-6">
              <p className="overline text-white/60">Founder voice</p>
              <p className="font-heading font-800 text-2xl mt-1">Marc Black, CEO</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="overline text-blaze mb-4">About the show</p>
          <h2 className="font-heading font-800 tracking-tight text-4xl sm:text-5xl leading-tight">
            For the listener who knows there is more in them.
          </h2>
          <p className="mt-6 text-white/70 leading-relaxed">
            Motivation Unlocked is more than a podcast — it's a mindset shift. The show is
            built for people ready to take control of their lives and step into a better
            version of themselves. Each episode delivers real talk around mental strength,
            emotional growth, discipline, healing, and transformation.
          </p>

          <div className="mt-8 grid grid-cols-3 gap-4">
            {pillars.map((p) => (
              <div key={p.k} className="rounded-2xl border border-white/10 bg-charcoal p-4">
                <div className="font-heading font-800 text-blaze text-lg">{p.k}</div>
                <div className="text-xs text-white/50 mt-1">{p.v}</div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex items-center gap-3">
            <span className="overline text-white/40 mr-1">Follow Marc</span>
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                className="rounded-full border border-white/20 p-3 hover:bg-blaze hover:border-blaze transition-colors"
                aria-label={s.label}
                data-testid={`about-social-${s.label.toLowerCase()}`}
              >
                <s.icon size={16} />
              </a>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
